import { Dispatch, SetStateAction, useState } from 'react';

import { Box, Button } from '@mui/material';
import { useFormikContext } from 'formik';

import { ContentModal } from 'components/modal';
import { SubTitle } from 'components/text';
import { ListagemProvider } from 'context/ListagemContext';
import { CondicaoPagamento } from 'pages/complementar/condicao-pagamento/types';
import { ConfigPedidoCondicoesPagamentoModalGrid } from 'pages/compra/configuracao-pedido/components';

type ConfigPedidoCondicoesPagamentoModalProps = {
    id: number | null;
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
    onUpdateLoja: (cdLoja: number | null, condicoesPagamento: CondicaoPagamento[]) => void;
};

export function ConfigPedidoCondicoesPagamentoModal({ id, open, setOpen, onUpdateLoja }: ConfigPedidoCondicoesPagamentoModalProps) {
    const [selectedCondicoesPagamento, setSelectedCondicoesPagamento] = useState<CondicaoPagamento[]>([]);

    return (
        <ContentModal closeButton open={open} setOpen={setOpen} sx={{ padding: 2, borderRadius: 1, width: { xs: '90vw', sm: 700 } }}>
            <SubTitle label="Condições de Pagamento" />

            <ListagemProvider>
                <ConfigPedidoCondicoesPagamentoModalGrid
                    id={id}
                    open={open}
                    selectedCondicoesPagamento={selectedCondicoesPagamento}
                    setSelectedCondicoesPagamento={setSelectedCondicoesPagamento}
                />
            </ListagemProvider>

            <Box sx={{ display: 'flex', justifyContent: 'end', gap: 2, mt: 2 }}>
                <Button variant="outlined" onClick={() => setOpen(false)}>
                    Cancelar
                </Button>

                <Button
                    variant="contained"
                    onClick={() => {
                        onUpdateLoja(id, selectedCondicoesPagamento);
                        setOpen(false);
                    }}
                >
                    Incluir
                </Button>
            </Box>
        </ContentModal>
    );
}
